import { styled } from '@mui/material/styles';
import { Typography, Chip } from '@mui/material';
import { emphasize } from '@mui/system/colorManipulator';

export const RootContainer = styled('div')(({ theme }) => ({
  flexGrow: 1,
  marginTop: theme.spacing(),
  marginBottom: theme.spacing(),
  '& > div': {},
  '& > div > div > label': {
    padding: '0 4px',
    top: 0,
    left: -3,
    zIndex: 2
  },
  '&.invalid > div > div > label': {
    color: '#FF4635'
  },
  '&.invalid fieldset': {
    borderColor: '#FF4635'
  },
  '&.invalid fieldset:hover': {
    borderColor: '#FF4635'
  },
  '& > div :before': {
    display: 'none'
  },
  '& > div :after': {
    display: 'none'
  }
}));

export const InputContainer = styled('div')({
  '&&': {
    display: 'flex',
    padding: '6px 8px',
    minHeight: 54,
    height: 'auto'
  }
});

export const ValueContainerDiv = styled('div')({
  position: 'relative',
  display: 'flex',
  flexWrap: 'wrap',
  flex: 1,
  alignItems: 'center',
  overflow: 'hidden',
  '& > div': {
    marginLeft: 5
  },
  '& > div[role=button]': {
    marginLeft: 2
  }
});

export const StyledChip = styled(Chip, {
  shouldForwardProp: prop => prop !== 'isFocused'
})(({ theme, isFocused }) => ({
  margin: '4px 2px',
  ...(isFocused && {
    backgroundColor: emphasize(
      theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08
    )
  })
}));

export const MessageTypography = styled(Typography)(({ theme }) => ({
  padding: `${theme.spacing()} ${theme.spacing(2)}`
}));

export const SingleValueTypography = styled(Typography)({
  fontSize: 16
});

export const PlaceholderTypography = styled(Typography)({
  position: 'absolute',
  left: 13,
  fontSize: 16
});

export const ErrorContainer = styled('div')({
  fontSize: '0.75rem',
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  margin: '8px 12px 0',
  color: '#FF4635'
});
